__turbopack_context__.v({
  "container": "DateContent-module-scss-module__06iTTa__container",
});
